/**
 * 所有常量
 */
export const CONSTANT = {
	 APP_THEME_COLOR : "#006e3f",
	 TX_KEY : "XXFBZ-QI7K3-DWV3F-3UC63-WW6X6-M5FWF",
	 APP_CODE : "yoedong"
}